import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/SocialCallback.css';

const NaverCallback = () => {
  const navigate = useNavigate();
  const { naverLogin } = useAuth();
  
  useEffect(() => {
    // 네이버 로그인 콜백 처리
    const processNaverLogin = async () => {
      // 네이버 로그인 객체가 있는지 확인
      if (!window.naver || !window.naver.LoginWithNaverId) {
        console.error('네이버 로그인 SDK를 로드할 수 없습니다.');
        navigate('/login?error=naver_sdk_load_failed');
        return;
      }
      
      // 네이버 로그인 인스턴스 초기화
      const naverLoginInstance = new window.naver.LoginWithNaverId({
        clientId: process.env.REACT_APP_NAVER_CLIENT_ID,
        callbackUrl: `${window.location.origin}/auth/naver/callback`,
        isPopup: false
      });
      
      naverLoginInstance.init();
      
      // 로그인 상태 확인
      naverLoginInstance.getLoginStatus(async (status) => {
        if (status) {
          // 사용자 정보 가져오기
          const { email, name, id, access_token } = naverLoginInstance.user;
          
          if (!email || !id) {
            console.error('네이버 계정에서 필수 정보를 가져올 수 없습니다.');
            navigate('/login?error=naver_info_missing');
            return;
          }
          
          // 이름 분리 (성과 이름)
          let firstName = '';
          let lastName = '';
          
          if (name) {
            const nameParts = name.split(' ');
            if (nameParts.length > 1) {
              lastName = nameParts[0];
              firstName = nameParts.slice(1).join(' ');
            } else {
              firstName = name;
              lastName = '';
            }
          }
          
          // 부모 창으로 데이터 전달 (팝업인 경우)
          if (window.opener) {
            window.opener.postMessage({
              type: 'naver_login',
              data: {
                token: access_token,
                email,
                firstName,
                lastName,
                naverId: id
              }
            }, window.location.origin);
            window.close();
          } else {
            // 직접 로그인 처리
            try {
              const success = await naverLogin(access_token, {
                email,
                firstName,
                lastName,
                naverId: id
              });
              
              if (success) {
                navigate('/dashboard');
              } else {
                navigate('/login?error=naver_login_failed');
              }
            } catch (error) {
              console.error('네이버 로그인 처리 중 오류:', error);
              navigate('/login?error=naver_login_error');
            }
          }
        } else {
          console.error('네이버 로그인 상태 확인 실패');
          navigate('/login?error=naver_login_status_failed');
        }
      });
    };
    
    processNaverLogin();
  }, [navigate, naverLogin]);
  
  return (
    <div className="social-callback-container">
      <div className="loading-spinner"></div>
      <p>네이버 로그인 처리 중입니다. 잠시만 기다려주세요...</p>
    </div>
  );
};

export default NaverCallback; 